import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

type SkipAuditAttemptStore = {
  skipAuditAttemptIds: Set<string>;
  addSkipAuditAttemptId: (skipAuditAttemptId: string) => void;
  setSkipAuditAttemptIds: (skipAuditAttemptIds: string[]) => void;
  removeSkipAuditAttemptId: (skipAuditAttemptId: string) => void;
};

const initialState = {
  skipAuditAttemptIds: new Set<string>(),
};

export const useSkipAuditAttemptsStore = create<SkipAuditAttemptStore>()(
  devtools(
    set => ({
      ...initialState,
      addSkipAuditAttemptId: (skipAuditAttemptId: string) => {
        set(state => ({
          skipAuditAttemptIds: new Set<string>([...state.skipAuditAttemptIds, skipAuditAttemptId]),
        }));
      },
      setSkipAuditAttemptIds: (skipAuditAttemptIds: string[]) => {
        set(_ => ({
          skipAuditAttemptIds: new Set<string>(skipAuditAttemptIds),
        }));
      },
      removeSkipAuditAttemptId: (skipAuditAttemptId: string) => {
        set(state => {
          const newSkipAuditAttemptIds = new Set<string>(state.skipAuditAttemptIds);
          newSkipAuditAttemptIds.delete(skipAuditAttemptId);
          return {
            skipAuditAttemptIds: newSkipAuditAttemptIds,
          };
        });
      },
    }),
    {
      name: 'skip-task-store',
    },
  ),
);
